import React from "react";

import uuid from "uuid";

export default function useID() {
	return React.useMemo(() => `id-${uuid()}`, []);
}
